<template>
  <div>
    <!--<div class="draw-pop" v-if="isShowLuckying">-->
    <!--<h2 class="draw-tit">{{ luckyName }}<strong>即将揭晓</strong></h2>-->
    <!--<div class="draw-ing">抽奖进行中..</div>-->
    <!--<div class="draw-con">-->
    <!--<div class="draw-people">-->
    <!--<div class="icon-drawpeople rotate-animation">-->
    <!--<img src="../../assets/images/icon-drawpeople.png" alt="" />-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="draw-pop" v-if="isShowLuckyList">-->
    <!--<span class="icontemp stemp-close close" @click="close()"></span>-->

    <!--<h2 class="draw-tit">{{ luckyName }}<strong>中奖名单</strong></h2>-->
    <!--<div class="draw-ing" v-if="isWinner">恭喜您，中奖了！</div>-->

    <!--<div class="draw-con draw-name-list" style="color: #ffd800;">-->
    <!--&lt;!&ndash;没有滚动条的时候去掉content的类名，出现滚动条的时候加上&ndash;&gt;-->
    <!--<div class="draw-people draw-list content">-->
    <!--<GeminiScrollbar ref="scroll" :autoshow="true" class="my-scroll-bar">-->
    <!--<div class="winner-name" v-for="(p, i) in winnerList" :key="i">-->
    <!--{{ p.showName }}-->
    <!--</div>-->
    <!--</GeminiScrollbar>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--中奖名单弹窗开始-->
    <!--<div class="winning-list" v-if="isShowWinningList">-->
    <!--<div>-->
    <!--<a class="icon-o-close" href="javascript:void (0);" @click="close()"-->
    <!--&gt;&times;</a-->
    <!--&gt;-->
    <!--<h2>中奖名单</h2>-->
    <!--</div>-->

    <!--<GeminiScrollbar ref="scroll" :autoshow="true" class="lottery-scroll-bar">-->
    <!--<div class="winning-list-con winnerListOver">-->
    <!--<div class="winning-item" v-for="(l, i) in luckyList" :key="i">-->
    <!--<div class="prize">-->
    <!--<span>{{ l.name }}</span>-->
    <!--<span>{{ l.awardName }}</span>-->
    <!--</div>-->
    <!--<div class="winner-list">-->
    <!--<div class="name" v-for="(w, i) in l.members" :key="i">-->
    <!--<span>{{ w.showName }}</span-->
    <!--&gt;<br />-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--&lt;!&ndash;/ko&ndash;&gt;-->
    <!--</div>-->
    <!--</GeminiScrollbar>-->
    <!--</div>-->
    <!--中奖名单弹窗结束-->
    <div class="draw-warp" v-if="isShowLuckying">
      <span class="icontemp stemp-close close" @click="close()"></span>
      <div class="header">
        <span class="name">{{ luckyName }}</span>
        <span>即将揭晓</span>
      </div>
      <div class="draw-img">
        <div class="draw-img-border">
          <img
            :src="luckyImageUrl ? luckyImageUrl : luckyDrawDefImg"
            alt=""
            class="draw-img-img"
          />
        </div>
      </div>
      <div class="draw-name">{{ awardName }}</div>
      <div class="draw-content">
        <div class="drawing-tips">抽奖进行中</div>
        <div class="drawing-img">
          <img src="../../assets/images/roll.gif" alt="" />
        </div>
      </div>
    </div>
    <div class="draw-warp" v-if="isShowLuckyList">
      <span class="icontemp stemp-close close" @click="close()"></span>
      <div class="header">
        <span class="name">{{ luckyName }}</span>
        <span>中奖名单</span>
      </div>
      <div class="draw-img">
        <div class="draw-img-border">
          <img
            :src="luckyImageUrl ? luckyImageUrl : luckyDrawDefImg"
            alt=""
            class="draw-img-img"
          />
        </div>
      </div>
      <div class="draw-name">{{ awardName }}</div>
      <div class="draw-content">
        <div class="drawing-tips">
          {{ isWinner ? "恭喜您中奖了" : "很遗憾，您没中奖" }}
        </div>
        <!--<div class="drawing-img">-->
        <!--<img src="../../assets/images/roll.gif" alt="">-->
        <!--</div>-->

        <div class="draw-winning-list">
          <GeminiScrollbar ref="scroll" :autoshow="true">
            <div class="list-item">
              <div
                class="name"
                :style="{
                  margin: winnerList.length > 1 ? '' : 'auto',
                  width: winnerList.length > 1 ? '50%' : '100%',
                  'text-align': winnerList.length > 1 ? '' : 'center'
                }"
                v-for="(p, i) in winnerList"
                :key="i"
              >
                {{ p.showName }}
              </div>
            </div>
          </GeminiScrollbar>
        </div>
      </div>
    </div>
    <div class="draw-warp" v-if="isShowWinningList">
      <span class="icontemp stemp-close close" @click="close()"></span>
      <div class="header header-list">
        <span>中奖名单</span>
      </div>
      <GeminiScrollbar ref="scroll" :autoshow="true" class="lottery-scroll-bar">
        <div class="all-draw">
          <div class="draw-item" v-for="(l, i) in luckyList" :key="i">
            <div class="draw-list-name">{{ l.name }}</div>
            <div class="draw-list-content">
              <div class="draw-img">
                <img :src="l.image ? l.image : luckyDrawDefImg" alt="" />
              </div>
              <div class="draw-s-name">{{ l.awardName }}</div>
              <div class="draw-winn-list">
                <div
                  class="name"
                  :style="{ width: l.members.length > 1 ? '50%' : '100%' }"
                  v-for="(w, i) in l.members"
                  :key="i"
                >
                  {{ w.showName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </GeminiScrollbar>
    </div>
  </div>
</template>

<script>
//  import { $subscriber } from "fire-wind-water";
//  import ws from "../../services/webinar";
import {
  buildLotteryData,
  buildTableMethod,
  mounted
} from "../../common/lottery";
export default {
  name: "Lottery",
  data() {
    return buildLotteryData({});
  },
  created() {},
  methods: buildTableMethod({}),
  //    close() {
  //      this.isShowLuckying = false;
  //      this.isShowLuckyList = false;
  //      this.isShowWinningList = false;
  //    },
  //    showLuckying() {
  //      this.isShowLuckying = true;
  //    },
  //    showLuckyList() {
  //      this.isShowLuckyList = true;
  //    },
  //    encryptUserInfo(val, type) {
  //
  //      var encryptor = {
  //        email: function (val) {
  //          var prefix = val.replace(/^(.*)@.*$/, '$1');
  //          if (prefix.length < 5) {
  //            return val.replace(/^[^@]*@(.*)$/, '****@$1');
  //          }
  //          return val.replace(/^(\w{2}).*(\w{2})@(.*)$/, '$1****$2@$3');
  //        },
  //        qq: function (val) {
  //          if (val.length < 4) {
  //            return val[0] + '****';
  //          }
  //          return val.replace(/^(\d{2})\d+(\d{2})$/, '$1****$2');
  //        },
  //        mobile: function (val) {
  //          if (val.length !== 11) {
  //            return val.replace(/^(.*)([\w]{4})$/, '****$2');
  //          }
  //          return val.replace(/^(\w{3})\w{4}(\w{4})$/, '$1****$2');
  //        }
  //      };
  //      if (Object.prototype.hasOwnProperty.call(encryptor, type)) {
  //        if (typeof val !== 'string') {
  //          return val;
  //        }
  //
  //        return encryptor[type](val);
  //      }
  //
  //      return val;
  //    },
  //
  //    //获取显示名
  //    getShowName(userInfo, index) {
  //      let self = this;
  //      var infoList = ['mobile', 'email', 'qq', 'nickName'];
  //      if (!index) {
  //        index = 0;
  //      }
  //      var userName = userInfo['userName'] || userInfo['realName'] || '';
  //      if (!userName.length) {
  //        userName = '匿名';
  //      }
  //      var info = infoList[index];
  //      if (userInfo[info]) {
  //        return userName + self.encryptUserInfo(userInfo[info], info);
  //      } else {
  //        if (index < infoList.length) {
  //          index++;
  //          return self.getShowName(userInfo, index);
  //        } else {
  //          return userName;
  //        }
  //      }
  //    },
  //    getLuckyDrawRoster(){
  //      var self = this;
  //      let params = {
  //        tenantId:self.webinarInfo.tenantId,
  //        instanceId:self.webinarInfo.instanceId
  //      }
  //      ws.getLotteryRecord(params).subscribe((data)=>{
  //        if(data.result == 0) {
  //          let list = data.content;
  //          for(let i in list){
  //            self.winnerListHandler(list[i].members);
  //          }
  //          self.luckyList = list;
  //          self.isShowWinningList = true;
  //        }
  //      })
  //    },
  //    winnerListHandler(winnerList){
  //      let self = this;
  //      for(let i in winnerList) {
  //        let winner = winnerList[i];
  //        winner.showName = self.getShowName(winner);
  //        winner.name = winner.name || self.encryptUserInfo(winner.mobile, 'mobile') || self.encryptUserInfo(winner.email, 'email');
  //        if(winner.userid == self.user.applicantId){
  //          self.isWinner  = true;
  //        }
  //      }
  //      return winnerList;
  //    }
  mounted() {
    //    let self = this;
    //    $subscriber.subscribe("webinarInfo", data => {
    //      console.log('webinarInfo：',data);
    //      self.webinarInfo = data;
    //    });
    //    $subscriber.subscribe("userInfo", data => {
    //      console.log('用户信息：',data);
    //      self.user = data;
    //    });
    //    $subscriber.subscribe('onLuckyDraw',(data)=>{
    //      console.log(data);
    //      self.luckyName = data.name;
    //      self.isShowLuckying = true;
    //    });
    //    $subscriber.subscribe('onLuckyDrawEnd',(data)=>{
    //      self.winnerList = data.data.members;
    //      self.luckyName = data.name;
    //      self.winnerListHandler(self.winnerList);
    ////      for(let i in self.winnerList) {
    ////        let winner = self.winnerList[i];
    ////        winner.showName = self.getShowName(winner);
    ////        winner.name = winner.name || self.encryptUserInfo(winner.mobile, 'mobile') || self.encryptUserInfo(winner.email, 'email');
    ////        if(winner.userid == self.user.applicantId){
    ////          self.isWinner  = true;
    ////        }
    ////      }
    //      self.isShowLuckying = false;
    //      self.showLuckyList();
    //    })
    //    $subscriber.subscribe('getLuckyDrawRoster',()=>{
    //      self.getLuckyDrawRoster();
    //    })

    return mounted(this);
  }
};
</script>

<style scoped></style>
